// Path: ./src/utils/constant/initialGridSortModel.ts
import { GridSortModel } from "@mui/x-data-grid";

export const initialGridSortModel: GridSortModel = [
  //   {
  //     field: "updatedAt",
  //     sort: "desc",
  //   },//TODO: if you touch code here, please refactor. if you don't know the issue, please talk to me will come back and fix later. enable this causing calling the sort table multiple times and we don't know why yet. create flyer item page is fine, but upload menu or upload flyer page is not fine
];
